import React from 'react';
import './Thinwallproduct.css';
import machineImage from '../../../imgs/Thinwallprod.webp'; 
import Reqprodcte from "../../../components/Reqprodcte";


const Thinwallproduct = () => {
  return (
    <div className="thinwall-container">
      <div className="thinwall-card text-card">
        <h2>High Speed Injection Molding Machine For Thin-Wall Product</h2>
        <h3>KF SERIES</h3>
        <p>
          KF Series Thin Wall Injection Molding Machine is specialized for thin-wall products like: food container, plastic cup, cap and so on.
        </p>
        <ul>
          <li><strong>Clamping Force:</strong> 1600~3800(KN)</li>
          <li><strong>Driving System:</strong> Hydraulic</li>
          <li><strong>Motor Type:</strong> Servo or Variable</li>
          <li><strong>Applications:</strong> Food Packaging, Mobile, Medical, Electronic Parts</li>
        </ul>
 <div className='stnd'>
                    <Reqprodcte />
                </div>      </div>

      <div className="thinwall-card-1" data-aos="fade-down">
        <img src={machineImage} alt="Thin Wall Injection Machine"  className="thinwall-card-img"/>
      </div>
    </div>
  );
};

export default Thinwallproduct;
